var map = {
	"./bg-pattern-bottom-desktop.svg": "5d6b",
	"./bg-pattern-bottom-mobile.svg": "8b6e",
	"./bg-pattern-top-desktop.svg": "4076",
	"./bg-pattern-top-mobile.svg": "574f",
	"./favicon-32x32.png": "9049",
	"./icon-star.svg": "c6db",
	"./image-anne.jpg": "a424",
	"./image-colton.jpg": "556e",
	"./image-irene.jpg": "210e"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "e264";